var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.allowed)?_vm._t("default"):_vm._t("notAllowed")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }